module.exports = (__parcel__import__("dUK3v")).then(() => parcelRequire('fyWP3'));